export default __webpack_public_path__ + "static/media/line-h-14.2cfdefd4.png";